import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import { initDesktop } from './utils/desktop';
import './hooks/useTheme'; // apply persisted theme before render
import './styles/classic.css';
import App from './App';

// Ponte nativa antes do render: no navegador é no-op, no Neutralino registra o
// handler de fechamento (sem ele o processo fica órfão ao clicar no X).
initDesktop();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Service worker desabilitado - limpeza feita inline no index.html
